import * as _ from 'lodash';
import { AfterViewInit, Component, inject, OnDestroy, OnInit, OutputEmitterRef, Signal, TemplateRef } from '@angular/core';
import { EMPTY, from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { unwrapData } from 'src/app/infrastructure/functions/unwrap-data.operator';

import { ApiService } from 'src/app/infrastructure/services/api-service/api.service';
import { _CentralPageService } from 'src/app/features/shared/central-page/services/_central-page.service';
import { FooterService } from 'src/app/features/shared/footer/footer.service';
import { FormComponent } from 'src/app/features/shared/form/container/form.component';
import { HeaderService } from 'src/app/features/shared/header/services/header.service';
import { HttpParams } from '@angular/common/http';
import { IFooterData } from 'src/app/features/shared/footer/models/footer-data';
import { IHeaderData } from 'src/app/features/shared/header/models/header-data';
import { InputControlComponent } from 'src/app/features/shared/controls/container/input-control/input-control.component';
import { LoadingPageService } from 'src/app/infrastructure/services/loading-services/loading-page.service';
import { routePage } from 'src/app/infrastructure/services/route-service/models/route-page';
import { SharedModule } from 'src/app/features/shared/shared.module';
import { _FormModelService } from 'src/app/infrastructure/services/model-services/_form-model.service';
import { _PageService } from 'src/app/infrastructure/services/page-services/_page.service';
import { _SectionEditComponent } from 'src/app/infrastructure/components/section-components/_section-edit-component';
import { ActivatedRouteService } from 'src/app/infrastructure/services/route-service/activated-route.service';
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';
import { IUserDto, userDto } from 'src/assets/common/models/user-dto.g';
import { IAccountData, accountData } from '../../models/account-data';
import { IAccountForm } from '../../models/account-form';
import { CLAIM_PAGE } from 'src/app/infrastructure/injection-tokens/PAGE-NAME';
import { pageSectionName } from 'src/app/infrastructure/services/page-services/models/page-section-name';

@Component({
    selector: 'app-account-edit',
    templateUrl: './account-edit.component.html',
    styleUrls: [
        './account-edit.component.scss'
    ],
    standalone: true,
        providers: [
        { provide: CLAIM_PAGE, useFactory: () => inject(CLAIM_PAGE, { skipSelf: true, optional: true }) ?? pageSectionName.accountEdit },
        ],
    imports: [
        SharedModule,
        FormComponent,
        InputControlComponent,
    ],
})
export class AccountEditComponent
    extends _SectionEditComponent<IUserDto, IAccountData, IAccountForm>
    implements AfterViewInit, OnInit, OnDestroy
{
    private readonly __apiService = injectRequired(ApiService);

    protected override readonly _activatedRouteService = injectRequired(ActivatedRouteService);
    protected override readonly _centralPageService = injectRequired(_CentralPageService);
    protected override readonly _footerService = injectRequired(FooterService);
    protected override readonly _formModelService = injectRequired(_FormModelService);
    protected override readonly _headerService = injectRequired(HeaderService);
    protected override readonly _loadingPageService = injectRequired(LoadingPageService);
    protected override readonly _pageService = injectRequired(_PageService);

    override out_onCancel = this._out_onCancel;
    override out_onDirty$$ = this._out_onDirty;
    override out_onEnter$$ = this._out_onEnter;
    override out_onEscape = this._out_onEscape;
    override out_onFormReset$$ = this._out_onFormReset;
    override out_onPageLoaded = this._out_onPageLoaded;
    override out_onSave = this._out_onSave;

    override autoFocus$$ = this._input_AutoFocus$$;
    override dataModel$$ = this._dataModel$$;
    override form$$ = this._form$$;
    override formControls$$ = this._formControls$$;
    override showError$$ = this._showError$$;
    override template_footerLeft$$ = this._template_footerLeft$$;
    override template_sectionDetails_extraButtons$$ = this._template_sectionDetails_extraButtons$$;
    override template_sectionEdit_extraButtons$$ = this._template_sectionEdit_extraButtons$$;

    override footerData: Partial<IFooterData> = {};
    override headerData: Partial<IHeaderData> = {
        sideBlockLeft_noClick: true,
    };
    override onCreate_httpParams: HttpParams | null = null;
    override onCreate_requestOptions: any = null;
    override onEdit_httpParams: HttpParams = new HttpParams();
    override onEdit_requestOptions: any = null;

    control_correspondenceName = this._formControls$$()?.[accountData.correspondenceName];
    control_email = this._formControls$$()?.[accountData.email];
    control_firstName = this._formControls$$()?.[accountData.firstName];
    control_lastName = this._formControls$$()?.[accountData.lastName];
    control_applicationName = this._formControls$$()?.[accountData.applicationName];
    value_correspondenceName: string | null = null;
    value_email: string | null = null;
    value_firstName: string | null = null;
    value_lastName: string | null = null;
    value_applicationName: string | null = null;

    constructor() {
        super();
    }

    override ngOnInit(): void {
        super._ngOnInit();
    }

    override emit_onCancel(): void {
        super._emit_onCancel();
    }

    override emit_onDirty(dirty: boolean): void {
        super._emit_onDirty(dirty);
    }

    override emit_onEnter(): void {
        this._emit_onEnter();
    }

    override emit_onEscape(): void {
        super._emit_onEscape();
    }

    override emit_onSave(): void {
        super._save(routePage.account);
    }

    override emit_pageLoaded(): void {
        super._emit_pageLoaded();
    }

    protected override _create_post$(_dto: any, _httpParams: HttpParams | null, _requestOptions: any) { return EMPTY; }

    protected override _edit_patch$(dto: IUserDto, _httpParams: HttpParams, _requestOptions: any): Observable<IUserDto> {
        return from(this.__apiService.PATCH('/api/Account/edit', {
            body: {
                guid:               dto[userDto.guid]               ?? undefined,
                applicationName:    dto[userDto.applicationName]    ?? null,
                firstName:          dto[userDto.firstName]          ?? null,
                lastName:           dto[userDto.lastName]           ?? null,
                correspondenceName: dto[userDto.correspondenceName] ?? null,
            },
        })).pipe(unwrapData<any>(), map(() => dto));
    }

    override form_reset(): void {
        super._form_reset();
    }

    override ngAfterViewInit(): void {
        super._ngAfterViewInit();
    }

    override ngOnDestroy(): void {
        super._ngOnDestroy();
    }
}
